import { useRef } from "react";
import { useFluidCanvas } from "../hooks/useFluidCanvas";

export function FluidCursor() {
  const canvasRef = useRef(null);
  useFluidCanvas(canvasRef);
  return (
    <canvas
      ref={canvasRef}
      data-testid="fluid-cursor-canvas"
      className="fixed inset-0 w-full h-full z-[40] pointer-events-none"
    />
  );
}
